module.exports = __webpack_public_path__ + "img/fiji.6a69b614.svg";